import { http } from '@/utils/http';
import qs from 'qs';

const baseUrl = '/vote/2020project/2020double_live/controller.php';

// 直播列表
const getLiveList = (page: number | string) => {
  return http.get(`${baseUrl}?enews=live-list`, {
    params: {
      page,
    },
  });
};

// 视频列表
const getVideoList = (page: number | string) => {
  return http.get(`${baseUrl}?enews=video-list`, {
    params: {
      page,
    },
  });
};

// 云旅馆列表
const getTextList = (page: number | string) => {
  return http.get(`${baseUrl}?enews=text-list`, {
    params: {
      page,
    },
  });
};

// 直播详情
const getLiveDetail = (id: any) => {
  return http.get(`${baseUrl}?enews=live-detail`, {
    params: {
      id,
    },
  });
};

// 视频详情
const getVideoDetail = (id: any) => {
  return http.get(`${baseUrl}?enews=video-detail`, {
    params: {
      id,
    },
  });
};

// 云旅馆详情
const getTextDetail = (id: any) => {
  return http.get(`${baseUrl}?enews=text-detail`, {
    params: {
      id,
    },
  });
};

// 直播商品列表
const getLiveShop = (id: any, page: number | string) => {
  return http.get(`${baseUrl}?enews=live-shop`, {
    params: {
      id,
      page,
    },
  });
};
// 创建直播房间
const getLiveRoom = (liveType: number | string) => {
  return http.get(`${baseUrl}?enews=live-room`, {
    params: {
      liveType,
    },
  });
};

// 获取登录信息
const getUserInfo = () => {
  return http.post('/vote/public/controller.php?enews=user-info');
};

// 注册xmpp用户
interface IGenXmppUser {
  unionid?: string;
  udid?: any;
  appkey?: any;
  liveType: any;
}
const genXmppUser = (data: IGenXmppUser) => {
  return http.post(`${baseUrl}?enews=register`, qs.stringify(data));
};

// 评论录入
interface ISubmitComment {
  unionid?: string;
  udid?: any;
  appkey?: any;
  nickname: string;
  headImg: string;
  content: string;
  targetId: any;
}
const submitComment = (data: ISubmitComment) => {
  return http.post(`${baseUrl}?enews=comment-save`, qs.stringify(data));
};

// APP端评论列表接口
interface IHistoryComments {
  id?: string | number;
  liveType: any;
}
const getHistoryComments = (data: IHistoryComments) => {
  return http.get(`${baseUrl}?enews=comment-list`, {
    params: data,
  });
};

export {
  getLiveList,
  getVideoList,
  getTextList,
  getLiveDetail,
  getVideoDetail,
  getTextDetail,
  getLiveShop,
  getLiveRoom,
  getUserInfo,
  genXmppUser,
  submitComment,
  getHistoryComments,
};
